import { ModalPageView } from '@cotera/client/app/components/app/modal-manager/modal-manager';
import { Label, Text } from '@cotera/client/app/components/ui';
import { Button } from '@cotera/client/v0/components/ui/button';
import { Input } from '@cotera/client/v0/components/ui/input';
import { useState } from 'react';

export const AskToDelete: React.FC<{
  onRespond: (params: {}) => Promise<void>;
  itemName: string;
}> = ({ onRespond, itemName }) => {
  const [name, setName] = useState('');
  const [error, setError] = useState<string | null>(null);
  const [loading, setLoading] = useState(false);

  return (
    <ModalPageView
      title={`Delete ${itemName}`}
      subtitle={'Are you sure you want to delete this column?'}
      className="px-4 py-4"
    >
      <form className="flex flex-col gap-4">
        <div className="flex flex-col gap-2">
          <Label className="text-sm">Please type the column name</Label>
          <Input
            id="column-name-confirm"
            autoFocus
            placeholder={itemName}
            value={name}
            onChange={(e) => setName(e.target.value)}
          />
        </div>
        {error && (
          <Text.Caption className="text-destructive">{error}</Text.Caption>
        )}
        <div className="w-full flex justify-end">
          <Button
            type="submit"
            disabled={loading || name !== itemName}
            variant="destructive"
            icon="save"
            className="w-fit self-end"
            onClick={async (e) => {
              e.preventDefault();
              if (name === itemName) {
                setLoading(true);
                await onRespond({});
                setLoading(false);
              } else {
                setError('Incorrect dataset name');
              }
            }}
          >
            Delete
          </Button>
        </div>
      </form>
    </ModalPageView>
  );
};
